<template>
  <el-dialog
    :title="isNew ? '新增参数' : '参数修改'"
    :visible="formVisible"
    width="30%"
    :show-close="false"
    :close-on-click-modal="false"
    @closed="clearForm"
  >
    <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="left">
      <el-form-item label="key" prop="biKey">
        <el-input type="text" v-model="ruleForm.biKey" autocomplete="off" :disabled="isNew ? false : true"></el-input>
      </el-form-item>
      <el-form-item
        label
        prop="biValue"
        :rules="[
          {
            required: true,
            message: 'token1.0不可为空',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <span slot="label">
          token1.0
          <span style="color: red">*</span>
        </span>
        <el-input type="text" v-model="ruleForm.biValue" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label
        prop="tokenV2"
        :rules="[
          {
            required: true,
            message: 'token2.0不可为空',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <span slot="label">
          token2.0
          <span style="color: red">*</span>
        </span>
        <el-input type="text" v-model="ruleForm.tokenV2" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="text" v-model="ruleForm.remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="saveForm('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { insertSysPara } from "@/api/api.js";
export default {
  data() {
    return {
      ruleForm: this.ruleFormProps,
    };
  },
  props: {
    formVisible: Boolean,
    ruleFormProps: Object,
    isNew: Boolean,
  },
  methods: {
    cancelForm() {
      this.$emit("closeDialogForm", false);
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isNew) {
            //新增
            insertSysPara({
              data: JSON.stringify({
                biKey: this.ruleForm.biKey,
                biValue: this.ruleForm.biValue,
                tokenV2: this.ruleForm.tokenV2,
                remark: this.ruleForm.remark,
                isShow: 1,
              }),
            }).then((res) => {
              if (res.code === "0000") {
                this.$notify({
                  title: "tip",
                  message: "新增成功",
                  type: "success",
                });
                this.$emit("closeDialogForm", false);
                this.$store.dispatch("getParamSettingList");
              }
            });
          } else {
            //编辑
            let param = { ...this.ruleForm };
            this.$store.dispatch("modifyParam", {
              param,
              cb: (data) => {
                if (data.code !== "0000") {
                  this.$notify({
                    title: "tip",
                    message: "修改失败",
                    type: "error",
                  });
                } else {
                  this.$notify({
                    title: "tip",
                    message: "修改成功",
                    type: "success",
                  });
                  this.$emit("closeDialogForm", false);
                  this.$store.dispatch("getParamSettingList");
                }
              },
            });
          }
        } else {
          return false;
        }
      });
    },
    clearForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
  watch: {
    ruleFormProps: function (val) {
      this.ruleForm = val;
    },
  },
};
</script>
